var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatherCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.641,
    height: 13.641,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-copy",
    fill: "none",
    stroke: "#7a89a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13959",
    d: "M6.213 4.999h5.463a1.214 1.214 0 0 1 1.214 1.214v5.463a1.214 1.214 0 0 1-1.214 1.214H6.213a1.214 1.214 0 0 1-1.214-1.214V6.213a1.214 1.214 0 0 1 1.214-1.214Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13960",
    d: "M2.571 8.642h-.607A1.214 1.214 0 0 1 .75 7.427V1.964A1.214 1.214 0 0 1 1.964.75h5.463a1.214 1.214 0 0 1 1.214 1.214v.607"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherCopy);
export default __webpack_public_path__ + "static/media/feather-copy.35d7ab55693f6f783f6e2cc39418eb07.svg";
export { ForwardRef as ReactComponent };